/**
 * theme.ts
 * ニジ看護転職 デザイントークン（全LP共通）
 * カラー変更はこのファイルのみ修正すること
 */

/** メインアクセント：ビビッドピンク */
export const ACCENT      = '#F56B96';
/** グラデーション用ダーク */
export const ACCENT_DARK = '#E83D76';
/** ティール：安心感 */
export const TEAL        = '#5CBFB0';
/** ウォームホワイト背景（明るめ薄ピンク） */
export const BG_WARM     = '#FFF0F5';
/** ウォームホワイトボーダー */
export const BORDER_WARM = '#FFD6E8';
/** セクション薄ピンク背景 */
export const BG_SECTION  = '#FFE4EE';
